import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDarkMode } from "../../contexts/useDarkModeContext";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
const jobBoardNavbarButtons = [
  { text: "Home", route: "/companies" },
  { text: "New Company", route: "/create-company" },
  { text: "Company Details", route: "/company-details" },
  { text: "Job Details", route: "/job-details" },
];
function CompaniesNavbar() {
  const { darkMode, darkModeHandler } = useDarkMode();
  const [activeIndux, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        bgcolor: darkMode ? "#1C1C1C" : "#ffffff",

        px: "78px",
        alignItems: "center",
        borderBottom: "1px solid #E6E6E6",
        pt: "26px",
      }}
    >
      <Box sx={{ display: "flex", gap: "80px" }}>
        {" "}
        <Stack
          id="pitchers-logo-name"
          direction="row"
          // alignSelf="start"
          spacing={1}
        >
          <Box
            component="img"
            src="/images/pitchers.png"
            sx={{ width: "37px", height: "34px", borderRadius: "6px" }}
          ></Box>
          <Typography
            variant="body2"
            sx={{
              fontSize: "25px",
              fontWeight: "600",
              lineHeight: "30.26px",
              fontFamily: "Inter",
              color: darkMode ? "#FFFFFF" : "#161616",
            }}
          >
            Pitchers
          </Typography>
        </Stack>
        <Stack direction="row" sx={{ gap: "40px" }}>
          {jobBoardNavbarButtons.map((btn, i) => {
            const isActive = i === activeIndux;
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {" "}
                <Button
                  variant="text"
                  sx={{
                    color: darkMode ? "#FFFFFF" : "#0E0B33",
                    textTransform: "none",
                    px: "20px",
                    fontWeight: isActive ? "700" : "500",
                    fontFamily: "Inter",
                  }}
                  onClick={() => {
                    setActiveIndex(i);
                    navigate(btn.route);
                  }}
                >
                  {btn.text}
                </Button>
                {isActive && (
                  <Divider
                    orientation="horizontal"
                    sx={{
                      color: "#fddf59",
                      border: "2px solid #fddf59",
                      borderRadius: "50px",
                      mt: "16px",
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Stack>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          mt: "-20px",
          gap: "12px",
        }}
      >
        {darkMode ? (
          <Button
            variant="text"
            sx={{
              color: "#ffffff",
              textTransform: "none",
              "& .MuiButton-startIcon": {
                marginRight: "6px", // Removes default margin
              },
              border: "1px solid #ffffff",
              bgcolor: "#1C1C1C",
              borderRadius: "10px",
              px: "20px",
              py: "8px",
            }}
          >
            Sign In{" "}
          </Button>
        ) : (
          <List
            sx={{
              py: "0px",
              // mt: "-20px",
            }}
          >
            <ListItem
              sx={{
                p: "0px",
                flexDirection: "row-reverse",
                justifyContent: "end",
              }}
            >
              <ListItemAvatar
                sx={{
                  minWidth: "0px",
                  alignSelf: "start",
                }}
              >
                <Avatar
                  src="/images/notificationProfilePic.jpeg"
                  sx={{
                    objectFit: "cover",
                    bgcolor: "#EBEBEB",
                    width: 54,
                    height: 54,
                    display: "block",
                  }}
                ></Avatar>
              </ListItemAvatar>
              <Stack
                sx={{
                  pr: "6px",
                  mt: "6px",
                }}
              >
                {" "}
                <Typography
                  sx={{
                    color: darkMode ? "#FFFFFF" : "#0E0B33",
                    fontWeight: "600",
                    lineHeight: "14px",
                    fontSize: "16px",
                    pl: "0px",
                    pt: "0px",
                    textAlign: "right",
                    fontFamily: "Inter",
                  }}
                >
                  Sarah Johnson
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#B5B5B5",
                    fontSize: "14px",
                    lineHeight: "26px",
                    pl: "8px",
                    textAlign: "right",
                    fontWeight: "400",
                  }}
                >
                  Profile
                </Typography>
              </Stack>
            </ListItem>
          </List>
        )}

        <IconButton
          sx={{ p: "0px", alignSelf: "center" }}
          onClick={darkModeHandler}
        >
          {darkMode ? (
            <LightModeIcon sx={{ color: "#fddf59" }} />
          ) : (
            <DarkModeIcon sx={{ color: "#fddf59" }} />
          )}
        </IconButton>
      </Box>
    </Stack>
  );
}

export default CompaniesNavbar;
